import { applicationAreaFromPlan, machineIdentsFromPlan } from "./serviceOrderProducts";

function localDayKey(value) {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  const pad = (part) => String(part).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function earlier(current, candidate) {
  if (!candidate) return current;
  if (!current) return candidate;
  return new Date(candidate) < new Date(current) ? candidate : current;
}

function later(current, candidate) {
  if (!candidate) return current;
  if (!current) return candidate;
  return new Date(candidate) > new Date(current) ? candidate : current;
}

function workedHectaresFromExecutions(executions) {
  let total = 0;
  let reported = false;
  (executions || []).forEach((entry) => {
    (entry.checks || []).forEach((check) => {
      const hectares = Number(check && check.hectaresDone);
      if (!Number.isFinite(hectares) || hectares <= 0) return;
      total += hectares;
      reported = true;
    });
  });
  return { total, reported };
}

/**
 * Hectares já informados pelo operador e o período do rastro.
 * A ordem ainda não concluída acompanha o trabalho até agora.
 */
export function serviceOrderWorkProgress(obs, now = new Date()) {
  const plan = (obs && obs.service_order_plan) || {};
  const area = applicationAreaFromPlan(plan);
  const plannedHa = area && area.totalHa > 0 ? area.totalHa : null;
  const executions = Array.isArray(obs && obs.field_executions)
    ? obs.field_executions
    : [];
  const worked = workedHectaresFromExecutions(executions);

  const machines = new Set(machineIdentsFromPlan(plan));
  const operatorIds = new Set();
  (obs && obs.assigned_operators ? obs.assigned_operators : []).forEach((operator) => {
    const id = Number(operator && operator.id);
    if (id) operatorIds.add(id);
  });

  let periodStart = (obs && (obs.executed_start_date || obs.start_date)) || null;
  let periodEnd = (obs && (obs.executed_end_date || obs.end_date)) || null;

  executions.forEach((entry) => {
    const machineId = String((entry && entry.machineId) || "").trim();
    const machineName = String((entry && entry.machineName) || "").trim();
    if (machineId) machines.add(machineId);
    if (machineName) machines.add(machineName);
    const operatorId = Number(entry && entry.operatorId);
    if (operatorId) operatorIds.add(operatorId);
    periodStart = earlier(periodStart, entry && entry.startedAt);
    periodEnd = later(periodEnd, entry && entry.stoppedAt);
  });

  const orderHasStarted =
    Boolean(obs && obs.start_date && new Date(obs.start_date) <= now) ||
    executions.length > 0;
  if (obs && !obs.confirmed && orderHasStarted) {
    periodEnd = now;
  }

  const workedHa = plannedHa == null && !worked.reported ? null : worked.total;
  const remainingHa =
    plannedHa == null || workedHa == null
      ? null
      : Math.max(0, plannedHa - workedHa);

  return {
    plannedHa,
    workedHa,
    remainingHa,
    machineIdents: Array.from(machines).filter(Boolean),
    operatorIds: Array.from(operatorIds),
    fromDay: localDayKey(periodStart),
    toDay: localDayKey(periodEnd),
    hasTrailTarget: machines.size > 0 || operatorIds.size > 0,
  };
}

export function formatHectares(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
